var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import 'gridstack/dist/gridstack.min.css';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { User } from '@/models/User';
import Roster from '@/components/roster/Roster';
import NotificationsCard from '@/components/notifications-card/NotificationsCard';
import BookmarkWidget from '@/components/BookmarkWidget/BookmarkWidget.vue';
import { Group } from '@/models/Group';
import DataTable from '@/components/data-table/DataTable';
import ErrorHandler from '@/support/ErrorHandler';
import { excludeRoles } from '@/support/ExcludeRoles';
import AQuillEditor from '@/components/AQuillEditor/AQuillEditor.vue';
import GoalPlanner from '@/views/Groups/Tabs/GoalPlanner/GoalPlanner.vue';
import { GroupIncludes } from '@/models/Model';
import AStudentTable from '@/components/AStudentTable/AStudentTable.vue';
import ADashboardWidget from '@/components/ADashboardWidget/ADashboardWidget.vue';
import { GridStack } from 'gridstack';
import ALoader from '@/components/ALoader/ALoader.vue';
import FavoriteGroupItems from '@/components/FavoriteGroupItems/FavoriteGroupItems.vue';
import AsyncSelect from '@/components/async-select/AsyncSelect.vue';
import ANoteWidget from '@/components/ANoteWidget/ANoteWidget.vue';
import { Teacher } from '@/models/Teacher';
import GoalPlannerLogbookDialog from '@/views/Groups/Tabs/GoalPlanner/GoalPlannerLogbookDialog/GoalPlannerLogbookDialog.vue';
let Dashboard = class Dashboard extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = true;
        this.isInitialized = false;
        this.groups = [];
        this.selectedGroup = null;
        this.completeSelectedGroup = null;
        this.logBookDialogIsOpen = false;
        this.teacher = null;
        this.favouriteTabs = [];
        // #endregion
    }
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.fetchFavouriteTeacherGroup();
        await this.fetchTeacherGroups();
        await this.fetchFavouriteTabs();
        this.isLoading = false;
        await this.initializeGridStack();
        this.isInitialized = true;
    }
    async initializeGridStack() {
        await this.$nextTick();
        const gridContainer = document.querySelector('.grid-stack');
        GridStack.init({
            float: false,
            cellHeight: 150,
            marginTop: 16,
            marginRight: 16,
            marginBottom: 16,
            marginLeft: 16,
            column: 12,
            minRow: 1,
            animate: true,
        }, gridContainer);
    }
    onOpenLogBookDialog() {
        this.logBookDialogIsOpen = true;
    }
    // #region Async methods (api calls only)
    async fetchFavouriteTabs() {
        try {
            const setting = this.$store.state.settings.find((setting) => {
                return setting.key === 'favourite_tabs';
            });
            if (setting && setting.value) {
                this.favouriteTabs = setting.value.split(',');
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    async fetchFavouriteTeacherGroup() {
        try {
            this.teacher = await new Teacher().include('teacher').find(this.user.id);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async fetchTeacherGroups() {
        try {
            this.groups = await new Group()
                .filter({
                users: this.user.id,
            })
                .all();
            if (this.groups.length === 0) {
                this.selectedGroup = null;
                return;
            }
            if (this.teacher && this.teacher.teacher && this.teacher.teacher.favourite_group_id) {
                const foundGroup = this.groups.find((group) => {
                    return group.id === this.teacher.teacher.favourite_group_id;
                });
                if (foundGroup) {
                    this.selectedGroup = foundGroup;
                }
            }
            else {
                // Fallback to first group
                this.selectedGroup = this.groups[0];
            }
            await this.fetchCompleteSelectedGroup();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async fetchCompleteSelectedGroup() {
        if (!this.selectedGroup || !this.selectedGroup.id) {
            return;
        }
        this.isLoading = true;
        try {
            const completeGroup = await new Group()
                .include([
                GroupIncludes.AUDIT,
                GroupIncludes.CHAT,
                GroupIncludes.USERS,
                GroupIncludes.SUBJECTS,
                GroupIncludes.ROLES,
                GroupIncludes.PARENT,
                GroupIncludes.NOTES,
                GroupIncludes.PROJECTS,
                GroupIncludes.USER_PROJECTS,
                GroupIncludes.TYPE,
                GroupIncludes.SUB_GROUPS,
                GroupIncludes.LEVEL,
            ])
                .find(this.selectedGroup.id);
            this.completeSelectedGroup = completeGroup;
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoading = false;
            if (this.isInitialized) {
                await this.initializeGridStack();
            }
        }
    }
    // #endregion
    // #region Getters
    get exclude() {
        return excludeRoles[this.$store.state.version].scoolUsers.dashboard.includes(this.$store.state.Auth.roles[0].id);
    }
    get widgets() {
        return [
            {
                title: this.$tc('Period planner'),
                visible: this.isPeriodPlannerVersion,
                component: GoalPlanner,
                props: {
                    group: this.completeSelectedGroup,
                    isPlannable: false,
                    initialView: 'timeGridDay',
                },
                w: 8,
                h: 6,
            },
            {
                title: this.$tc('subject.tab.notes'),
                visible: !this.isPeriodPlannerVersion,
                component: ANoteWidget,
                ref: 'noteWidget',
                props: {
                    user: this.user,
                },
                actions: [
                    {
                        icon: 'save',
                        label: this.$tc('Save notes'),
                        visible: true,
                        action: () => {
                            const dashboardWidget = this.$children.find((child) => child.$refs && child.$refs.noteWidget);
                            if (dashboardWidget) {
                                const noteWidget = dashboardWidget.$refs.noteWidget;
                                noteWidget.saveNote();
                            }
                        },
                    },
                ],
                w: 7,
                h: 6,
            },
            {
                title: this.$tc('Saved bookmarks'),
                visible: true,
                component: BookmarkWidget,
                ref: 'bookmarkWidget',
                props: {
                    user: this.user,
                },
                actions: [
                    {
                        icon: 'add_link',
                        label: this.$tc('Add bookmark'),
                        visible: true,
                        action: () => {
                            const dashboardWidget = this.$children.find((child) => child.$refs && child.$refs.bookmarkWidget);
                            if (dashboardWidget) {
                                const bookmarkWidget = dashboardWidget.$refs.bookmarkWidget;
                                bookmarkWidget.onOpenBookmarkDialog();
                            }
                        },
                    },
                ],
                w: this.isPeriodPlannerVersion ? 4 : 5,
                h: this.isPeriodPlannerVersion ? 3 : 3,
            },
            {
                title: this.$tc('My favorites'),
                visible: this.isPeriodPlannerVersion || this.isScheduleVersion,
                component: FavoriteGroupItems,
                props: {
                    group: this.completeSelectedGroup,
                    favouriteTabs: this.favouriteTabs,
                },
                w: this.isScheduleVersion ? 5 : 4,
                h: 3,
            },
            {
                title: this.$tc('Students'),
                visible: this.isPeriodPlannerVersion,
                component: AStudentTable,
                props: {
                    group: this.completeSelectedGroup,
                    showTableTitle: false,
                    showCheckboxes: false,
                    showFilters: false,
                },
                w: 8,
                h: 4,
            },
            {
                title: this.$tc('My Messages'),
                visible: true,
                component: NotificationsCard,
                ref: 'notificationsCard',
                props: {
                    user: this.user,
                    isTeacherDashboard: true,
                    hideViewAllButton: true,
                    hideActionsMenu: true,
                },
                actions: [
                    {
                        icon: 'markunread',
                        label: this.$tc('notifications.view_all'),
                        visible: true,
                        action: () => {
                            this.$router.push('/notification-history');
                        },
                    },
                    {
                        icon: 'done_all',
                        label: this.$tc('notifications.delete_all'),
                        visible: true,
                        action: () => {
                            const dashboardWidget = this.$children.find((child) => child.$refs && child.$refs.notificationsCard);
                            if (dashboardWidget) {
                                const notificationsCard = dashboardWidget.$refs.notificationsCard;
                                notificationsCard.markAllAsRead();
                            }
                        },
                    },
                ],
                w: this.isPeriodPlannerVersion ? 4 : 5,
                h: this.isPeriodPlannerVersion ? 3 : 3,
                ...(this.isScheduleVersion ? { x: 7, y: 13 } : {}),
            },
            {
                title: this.$tc('tool.title'),
                visible: !this.exclude,
                component: Roster,
                props: {
                    user: this.user,
                },
                w: 12,
                h: 6,
                x: 0,
                y: 0,
            },
        ];
    }
    get scoolVersion() {
        const setting = this.$store.state.settings.find((setting) => {
            return setting.key === 'scool_version';
        });
        return setting ? setting.value : '3';
    }
    get isPeriodPlannerVersion() {
        const version = this.scoolVersion;
        return version === '4';
    }
    get isScheduleVersion() {
        const version = this.scoolVersion;
        return version === '3';
    }
    // #endregion
    // #region Watchers
    async selectedGroupChanged() {
        if (this.isInitialized) {
            await this.fetchCompleteSelectedGroup();
        }
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof User !== "undefined" && User) === "function" ? _a : Object)
], Dashboard.prototype, "user", void 0);
__decorate([
    Watch('selectedGroup'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], Dashboard.prototype, "selectedGroupChanged", null);
Dashboard = __decorate([
    Component({
        components: {
            DataTable,
            ADashboardWidget,
            NotificationsCard,
            BookmarkWidget,
            Roster,
            AQuillEditor,
            GoalPlanner,
            AStudentTable,
            ALoader,
            FavoriteGroupItems,
            AsyncSelect,
            ANoteWidget,
            GoalPlannerLogbookDialog,
        },
    })
], Dashboard);
export default Dashboard;
